<template>
  <div v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh" :class="{[classes] : true, [activeClasses]: true, /*'col-small': screenSizeId < 3  */ }">
    <slot></slot>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: 'ks-column',
  mixins: [checkPermissions],
  props: {
    viewRightDrawerIcon: {
      type: String,
      default: null
    },
    viewLeftDrawerIcon: {
      type: String,
      default: null
    },
    viewAfter: {
      type: String,
      default: null
    },
    viewBack: {
      type: String,
      default: null
    },
    customLeftButton: {
      type: Object,
      default() {
        return {
          show: false,
          click: () => {
            return true;
          },
          icon: false
        }
      },
    },
    customRightButton: {
      type: Object,
      default() {
        return {
          show: false,
          click: () => {
            return true;
          },
          icon: false
        }
      },
    },
    viewTitle: {
      type: String,
      default: null
    },
    viewName: {
      type: String,
      default: null
    },
    classes: {
      default: 'col'
    }
  },
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    activeView() {
      return app.activePage.currentView;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  watch: {
    'activeView.viewName': function (newVal) {
      if (this.viewName !== null) {
        this.isActive(newVal);
      }
    }
  },
  mounted() {
    if (this.$parent.multiCampaign) {
      this.multiCampaign = this.$parent.multiCampaign;
    }
    if (this.viewName) {
      app['activePage'].views.push({
        viewName: this.viewName,
        viewBack: this.viewBack,
        viewAfter: this.viewAfter,
        rightDrawerIcon: this.viewRightDrawerIcon,
        leftDrawerIcon: this.viewLeftDrawerIcon,
        customLeftButton: this.customLeftButton,
        customRightButton: this.customRightButton,
        title: this.viewTitle
      })
    }
  },
  methods: {
    isActive(active) {
      if (active === this.viewName) {
        this.activeClasses = '';
      } else {
        this.activeClasses = 'inactive-view';
      }
    }
  },
  data() {
    return {
      multiCampaign: null,
      activeClasses: ''
    }
  }
}
</script>
<style scoped>
.col-small {
  flex-basis: 0;
  -ms-flex-positive: 1;
  -webkit-box-flex: 1;
  flex-grow: 1;
  min-width: 0;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 0;
  padding-left: 0;
}
</style>
